import React from 'react';

import Icon from '../Icon/Icon';

const UpdateAppIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M32 53.5C43.8741 53.5 53.5 43.8741 53.5 32C53.5 20.1259 43.8741 10.5 32 10.5C20.1259 10.5 10.5 20.1259 10.5 32C10.5 43.8741 20.1259 53.5 32 53.5ZM32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.75 42.5909C21.75 41.9006 22.3096 41.3409 23 41.3409L41 41.3409C41.6904 41.3409 42.25 41.9006 42.25 42.5909C42.25 43.2813 41.6904 43.8409 41 43.8409L23 43.8409C22.3096 43.8409 21.75 43.2813 21.75 42.5909Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M31.9808 19.25C32.6712 19.25 33.2308 19.8096 33.2308 20.5V36.4228C33.2308 37.1132 32.6712 37.6728 31.9808 37.6728C31.2905 37.6728 30.7308 37.1132 30.7308 36.4228V20.5C30.7308 19.8096 31.2905 19.25 31.9808 19.25Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M24.5803 29.9984C25.0738 29.5156 25.8652 29.5242 26.348 30.0177L31.995 35.7897L37.6421 30.0177C38.1249 29.5242 38.9163 29.5156 39.4098 29.9984C39.9032 30.4812 39.9119 31.2726 39.4291 31.766L32.8885 38.4513C32.6534 38.6916 32.3313 38.8271 31.995 38.8271C31.6588 38.8271 31.3367 38.6916 31.1015 38.4513L24.561 31.766C24.0782 31.2726 24.0868 30.4812 24.5803 29.9984Z'
                fill='#FFFDFB'
            />
        </Icon>
    );
};

export default UpdateAppIcon;
